module.exports = __webpack_public_path__ + "src/assets/games/46/1.png";